var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#b7a475;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,14c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0,0.6-0.2,1.2c-0.2,0.6-1.2,1.1-1.7,1.1c-0.5,0-0.5,0.4-3-0.7 s-4-3.8-4.1-3.9c-0.1-0.2-1-1.4-0.9-2.6c0.1-1.2,0.7-1.8,1-2C8.5,7,8.8,7,8.9,7h0.5C9.6,7,9.8,6.9,10,7.4l0.7,1.9 c0.1,0.1,0.1,0.3,0,0.4l-0.3,0.4L10,10.6c-0.1,0.1-0.3,0.2-0.1,0.5c0.1,0.3,0.6,1.1,1.3,1.8c0.9,0.9,1.7,1.2,1.9,1.3 c0.2,0.1,0.4,0.1,0.5,0l0.8-0.9c0.2-0.2,0.4-0.2,0.6-0.1L16.8,14 M12,2c5.5,0,10,4.5,10,10s-4.5,10-10,10c-2,0-3.8-0.6-5.3-1.5L2,22 l1.5-4.6C2.6,15.8,2,14,2,12C2,6.5,6.5,2,12,2 M12,4c-4.4,0-8,3.6-8,8c0,1.7,0.5,3.3,1.5,4.6l-1,2.9l2.9-1C8.7,19.5,10.3,20,12,20 c4.4,0,8-3.6,8-8S16.4,4,12,4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.faefe241298a8d0e582f620113a57ef4.svg";
export { ForwardRef as ReactComponent };